import React from 'react';
import { TweenLite, Power2 } from 'gsap';
var Nudge = function Nudge() {
  return /*#__PURE__*/React.createElement("div", {
    className: "intro-banner__nudge"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(evt) {
      evt.preventDefault();
      var componentList = document.querySelectorAll('.content .component');
      var secondComponent = componentList.length > 1 ? componentList[1] : null;
      var offsetTop = secondComponent ? secondComponent.offsetTop : null;
      if (offsetTop) {
        TweenLite.to(window, 0.5, {
          scrollTo: offsetTop - 120,
          ease: Power2.easeInOut
        }); // subtract the height of the header
      }
    }
  }));
};
export default Nudge;